<template>
    <div class="approve_admin_add_management_wrap" v-loading="loading">
        <div class="admin_management_top">
            <div class="admin_management_top_return" @click="handleClickReturn">
                <i class="el-icon-arrow-left"></i> 返回
            </div>
            <div class="admin_management_top_tab">
                <ul>
                    <li v-for="item in tabList" :class="item.name == activeName ? 'active' : ''"
                        @click="handleClickTab(item)" v-text="item.label"></li>
                </ul>
            </div>
            <div class="admin_management_top_save">
                <el-button v-if="activeName === 'FormDesign'" size="small" @click="handleClickReview">预览</el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickRelease">发布
                </el-button>
            </div>
        </div>
        <div class="admin_management_bottom" v-if="dataLoading">
            <div v-show="activeName === 'BasicInformation'">
                <baseInfo ref="baseInfoRef" :base_info="approvalDetail.base_info" @editSuccess="editSuccess"></baseInfo>
            </div>
            <CustomFormSite
                    v-show="activeName === 'FormDesign'"
                    ref="customFormSite"
                    :can_set_show_rules="true"
                    :field_form="field_form"
                    :filter_field_type="filter_field_type"
                    :field_form_desc="'点击可对各字段单独设置，按住可拖动排序字段位置'"
                    :field_form_title="'表单预览区'"
                    :is_form_module="false"
                    :is_show_control_group="true"
                    :publish_btn_show="false"
                    :review_btn_show="false"
                    :review_form_type_list="reviewFormTypeList"
                    :source="'approve'"
                    @form-loading-change="loadingChange"
                    @del-field-condition="delFieldCondition"
                    @submit-fields="submitFields"
            ></CustomFormSite>
            <div v-show="activeName === 'ApprovalProcess'">
                <approvalProcess ref="approvalProcessRef"
                                 :approvalType="approvalDetail.base_info ? approvalDetail.base_info.type : ''"
                                 :fieldList="fieldList" :node_info="approvalDetail.node_info"
                                 @editSuccess="editSuccess"></approvalProcess>
            </div>
            <div v-show="activeName === 'MoreSettings'">
                <moreSettings ref="moreSettingsRef" :approvalType="approvalDetail.base_info ? approvalDetail.base_info.type : ''"
                              :fieldList="fieldList"
                              :more_setting="approvalDetail.more_setting" @editSuccess="editSuccess"></moreSettings>
            </div>
        </div>
    </div>
</template>
<script>
    import {approvalSetAdd, approvalSetDetail, approvalSetEdit} from "@/api/index.js"
    import baseInfo from './baseInfo'
    import approvalProcess from './approvalProcess'
    import moreSettings from './moreSettings'
    import CustomFormSite from "@/components/pComponents/CustomFormSite";
    import {EventBus} from '@/utils/eventBus';
    export default {
        name: "approveAdminSettings",
        components: {
            baseInfo,
            approvalProcess,
            moreSettings,
            CustomFormSite
        },
        data() {
            return {
                dataLoading: false,
                loading: false,
                approvalId: 0,
                btnDisabled: false,
                activeName: "BasicInformation",
                tabList: [
                    {name: "BasicInformation", label: "基本信息"},
                    {name: "FormDesign", label: "表单设计"},
                    {name: "ApprovalProcess", label: "审批流程"},
                    {name: "MoreSettings", label: "更多设置"},
                ],
                fieldList: [],

                submitFlag: false,
                reviewFormTypeList: [
                    {
                        title: '新增审批电脑端',
                        value: 'pc',
                        form_title: '新增审批',
                        form_desc: '模拟真实发起审批页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作。'
                    },
                    {
                        title: '新增审批移动端',
                        value: 'mobile',
                        form_title: '新增审批',
                        form_desc: '模拟真实发起审批页面效果，预览中填写的数据系统不会保存，有些控件如附件、图片、收付款账户、发票不支持在预览中操作。'
                    },
                ],
                approvalDetail: {},
                field_form: 'approve',
                filter_field_type:'',
                is_edit_flag: false, //是否编辑过
            }
        },
        created() {
            this.approvalId = this.$route.query.id;

        },
        mounted() {
            if (this.approvalId && this.approvalId > 0) {
                this.getApprovalDetail()
            } else {
                this.dataLoading = true
            }
        },
        methods: {
            // 获取详情
            getApprovalDetail() {
                this.loading = true
                approvalSetDetail({id: this.approvalId}).then(res => {
                    if (res.code === 200) {
                        let {base_info, node_info, more_setting} = res.data
                        this.approvalDetail = {
                            base_info: base_info,
                            node_info: node_info,
                            more_setting: more_setting,
                        }
                        if (base_info.is_system == 0) {
                            // this.field_form = 'customers'
                            this.field_form = 'approval_type_' + this.approvalId
                        } else {
                            this.tabList.splice(1, 1)
                            this.field_form =  this.approval_type_mapping(base_info.type)
                            if(base_info.type == 'order_purchase' || base_info.type == 'order_after_sale' || base_info.type == 'workorder_finish' || base_info.type == 'workorder_travel'){
                                this.filter_field_type = 'form_module'
                            }
                        }
                        this.loading = false
                        this.dataLoading = true
                        if(this.$route.query.tab_name){
                            this.activeName = this.$route.query.tab_name
                        }
                    }
                })
            },
            // 审批type 映射表明
            approval_type_mapping(type){
                let data = {
                    order_add:'orders',
                    order_purchase:'order_purchases',
                    order_after_sale:'order_after_sales',
                    quotation_add:'project_quotations',
                    workorder_create:'workorders',
                    workorder_travel:'workorder_assign'
                }
                return data[type] ? data[type] : type
            },

            // 是否编辑了
            editSuccess(data) {
                this.is_edit_flag = true
            },
            handleClickReturn() {

                if (this.is_edit_flag == false) {
                    this.$router.go(-1)
                    return false
                }
                const h = this.$createElement;
                this.$msgbox({
                    title: '您本次编辑内容还未发布！',
                    message: h('div', null, [
                        h('span', null, `直接退出将不会保存本次编辑内容，是否确认退出？`),
                    ]),
                    iconClass: 'icon-jinggao iconfont prompt_message_icon status1',
                    customClass: 'prompt_message_custom',
                    cancelButtonText: '取消',
                    confirmButtonText: '退出',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass: '',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    this.$router.go(-1)
                }).catch(() => {

                })
            },
            handleClickTab(item) {
                if (this.verificationFunction(this.activeName)) {
                    this.activeName = item.name;
                }
            },
            // 校验
            verificationFunction(type) {
                let flag = false
                if (type == 'BasicInformation') {
                    this.$refs.baseInfoRef.$refs.baseInfoForm.validate(valid => {
                        if (valid) {
                            flag = true
                        } else {
                            this.$message.error('请完善基本信息')
                        }
                    })
                } else if (type == 'FormDesign') {
                    this.submitFlag = false
                    this.$refs.customFormSite.handleClickPublish()
                    flag = this.submitFlag
                } else if (type == 'ApprovalProcess') {
                    this.$refs.approvalProcessRef.nodeValidate = true
                    this.$refs.approvalProcessRef.nodeInfoDataValidate(this.$refs.approvalProcessRef.nodeInfoData)
                    flag = this.$refs.approvalProcessRef.nodeValidate
                } else {
                    flag = true
                }
                return flag
            },
            submitFields(data) {
                this.submitFlag = false
                if (data && data.field_list) {
                    this.submitFlag = true
                }
                this.fieldList = data.field_list
                this.$refs.moreSettingsRef.getOverviewFields(data.field_list) //更新审批概览区字段
            },
            // 自定义字段组件加载完毕后通知的
            loadingChange(loading) {
                // 调用组件中的发布获取字段---handleClickPublish：发布   submitFields：获取
                this.$refs.customFormSite.handleClickPublish()
            },
            delFieldCondition(data) {
                this.$refs.approvalProcessRef.delFieldCondition(data)
            },

            // 预览表单
            handleClickReview() {
                this.$refs.customFormSite.handleClickReview()
            },
            // 发布
            handleClickRelease() {
                let flag = []
                this.tabList.forEach((item) => {
                    flag.push(this.verificationFunction(item.name))
                })
                if (!flag.every(item => item)) {
                    return false
                }
                if ((this.fieldList.length == 0 && !this.approvalId) || (this.approvalId && this.fieldList.length == 0 && this.approvalDetail.base_info.is_system == 0)) {
                    this.$message.error('请至少添加一个字段')
                    return false
                }
                let data = {
                    base_info: this.$refs.baseInfoRef.baseInfoForm,
                    form_info: this.fieldList,
                    node_info: this.$refs.approvalProcessRef.nodeInfoData,
                    more_setting: this.$refs.moreSettingsRef.moreSettingForm
                }
                if (this.approvalId && this.approvalDetail.base_info && this.approvalDetail.base_info.is_system == 1) {
                    data.form_info = {}
                }

                this.btnDisabled = true
                if (this.approvalId) {
                    data.id = this.approvalId
                    approvalSetEdit(data).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '发布成功',
                                duration: 1500,
                                onClose: () => {
                                    this.btnDisabled = false
                                    EventBus.$emit('listUpdated');
                                    this.$router.go(-1);
                                }
                            })
                        }
                    })
                } else {
                    approvalSetAdd(data).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '发布成功',
                                duration: 1500,
                                onClose: () => {
                                    this.btnDisabled = false
                                    EventBus.$emit('listUpdated');
                                    this.$router.go(-1);
                                }
                            })
                        }
                    })
                }

            },

            // 递归处理数据
            recursionData(node) {
                if (node.childNode && node.childNode.type) {
                    if (node.type != 'condition' && node.type != 'end') {
                        this.verificationFieldAuth(node)
                    }
                    this.recursionData(node.childNode);
                }
                if (node.conditionNodes && node.conditionNodes.length > 0) {
                    for (let i = 0; i < node.conditionNodes.length; i++) {
                        this.recursionData(node.conditionNodes[i]);
                    }
                }
            },


        }
    }
</script>
<style lang="scss" scoped>
    @import "@/styles/approval.scss";

</style>
